
import { useAuthStore } from '~/store/auth'
import { useEventStore } from '~/store/event'
import { ref as refState} from 'vue'
import dayjs from 'dayjs'
import _debounce from 'lodash/debounce.js'
import _size from 'lodash/size.js'
import _find from 'lodash/find.js'
import _includes from 'lodash/includes.js'

const eventTrackingToday = () => {
  const route = useRoute()
  const eventStore = useEventStore()
  const authStore = useAuthStore()

  const eventData = computed(() => eventStore.eventData)
  const eventTrackingTodayData = computed(() => eventStore.eventTrackingTodayData)
  const userId = computed(() => authStore.userId)

  

  watch(() => route.path, async() => {

    if(!eventData.value || !userId.value ) {
      return console.log('ไม่มีข้อมูลงาน และ userId')
    }

    const lastStatusCode = eventTrackingTodayData.value[userId.value]
    const statusCode = getCurrentStatusCode()
    
    // ไม่เคยมีประวัติ
    if(!lastStatusCode) {
      await eventStore.updateEventTrackingPageToday(statusCode)
      console.log('today: update ครั้งแรก')
      return
    }

    // หน้าล่าสุดไกลกว่าประวัติที่เคยเขียน
    if(statusCode > lastStatusCode) {
      await eventStore.updateEventTrackingPageToday(statusCode)
      console.log('today: update หน้าล่าสุด')
      return
    }
  })


  function getCurrentStatusCode():any {
    const codes = [
      {
        code: 100,
        path: '/event/'
      },
      {
        code: 200,
        path: '/selectUploadAndWish'
      },
      {
        code: 300,
        path: '/selectTemplate'
      },
      {
        code: 400,
        path: '/editor'
      },
      {
        code: 500,
        path: '/thankyou'
      },
    ]

    if(_includes(route.path, '/event/')) {
      return codes[0]?.code
    }

    const data = _find(codes, c => _includes(c.path, route.path))
    return data?.code
  }
}

export default eventTrackingToday